import React, { useState } from 'react';
import { Filter } from 'lucide-react';
import { sampleVideos } from '../utils/mockData';
import { VideoModal, VideoCard } from '../components/VideoPlayer';
import Reveal from '../components/Reveal';

const SamplesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedVideo, setSelectedVideo] = useState(null);

  const categories = [
    { id: 'all', label: 'All Videos' },
    { id: 'memorial', label: 'Memorials' },
    { id: 'birthday', label: 'Birthdays' },
    { id: 'wedding', label: 'Weddings' },
    { id: 'special', label: 'Special Events' },
    { id: 'business', label: 'Business' }
  ];

  const filteredVideos = selectedCategory === 'all' 
    ? sampleVideos 
    : sampleVideos.filter(video => video.category === selectedCategory);

  return (
    <div className="min-h-screen bg-black pt-24 md:pt-40 pb-20">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <Reveal className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
            Sample <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600">Videos</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            See How We Bring Memories to Life - Watch Real Examples
          </p>
        </Reveal>

        {/* Category Filter */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
          <div className="flex items-center text-gray-400 mr-2">
            <Filter size={20} className="mr-2" />
            <span className="font-medium">Filter:</span>
          </div>
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-2.5 rounded-full font-medium transition-all duration-300 ${
                selectedCategory === category.id
                  ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-black shadow-lg shadow-amber-500/50'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredVideos.map((video, index) => (
            <Reveal key={video.id} delay={Math.min((index % 4) + 1, 4)}>
              <VideoCard
                video={video}
                onClick={() => setSelectedVideo(video)}
              />
            </Reveal>
          ))}
        </div>

        {/* Empty State */}
        {filteredVideos.length === 0 && (
          <div className="text-center py-20">
            <p className="text-gray-400 text-lg">
              No videos found in this category.
            </p>
          </div>
        )}

        {/* CTA Section */}
        <Reveal className="mt-20 text-center bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-12 border border-gray-700">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready For Your Own Professional Visual Experience?
          </h2>
          <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
            Let us create a beautiful, emotional experience from your precious memories
          </p>
          <a
            href="/pricing"
            className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-black font-semibold rounded-full hover:from-amber-600 hover:to-amber-700 transition-all duration-300 shadow-xl hover:shadow-amber-500/50 hover:scale-105 active:scale-95"
          >
            Order Now
          </a>
        </Reveal>

        {/* Video Modal */}
        {selectedVideo && (
          <VideoModal
            video={selectedVideo}
            onClose={() => setSelectedVideo(null)}
          />
        )}
      </div>
    </div>
  );
};

export default SamplesPage;
